module.exports = "<!-- Headers are included in the 'app' state template to avoid duplication -->\n<ui-view></ui-view>\n";


//////////////////
// WEBPACK FOOTER
// ./client/app.html
// module id = 1438
// module chunks = 0